import { render, staticRenderFns } from "./SpellcheckerAlert.vue?vue&type=template&id=36c27ac4&scoped=true&"
import script from "./SpellcheckerAlert.vue?vue&type=script&lang=js&"
export * from "./SpellcheckerAlert.vue?vue&type=script&lang=js&"
import style0 from "./SpellcheckerAlert.vue?vue&type=style&index=0&id=36c27ac4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c27ac4",
  null
  
)

export default component.exports